import type { Catalogue } from './en.js';

/** Dutch interface catalogue. Typed against English: a missing key will not build. */
export const nl: Catalogue = {
  'common.back': 'Terug',
  'common.cancel': 'Annuleren',
  'common.close': 'Sluiten',
  'common.copy': 'Link kopiëren',
  'common.copied': 'Gekopieerd',
  'common.copyShort': 'Kopiëren',
  'common.loading': 'Laden…',
  'common.save': 'Opslaan',
  'common.signOut': 'Uitloggen',
  'common.settings': 'Instellingen',
  'common.profile': 'Profiel',
  'common.branding': 'Chatvormgeving',
  'common.search': 'Zoeken',
  'common.menu': 'Menu',
  'common.retry': 'Opnieuw proberen',

  'error.generic': 'Er is iets misgegaan.',
  'error.notFound': 'Niet gevonden',
  'error.notFoundBody': 'Op dit adres staat niets.',

  'login.title': 'Inloggen',
  'login.subtitle': 'Geen wachtwoorden. We mailen u een eenmalige link.',
  'login.emailLabel': 'E-mailadres',
  'login.submit': 'Stuur mij een inloglink',
  'login.sentTitle': 'Controleer uw e-mail',
  'login.sentBody':
    'Als bij dat adres een account hoort, is er een inloglink onderweg. Die verloopt over {minutes} minuten en werkt één keer.',
  'login.sentNoticeTitle': 'De link openen logt u nog niet in',
  'login.sentNoticeBody':
    'U wordt gevraagd op „Doorgaan” te drukken. Dat is met opzet, zodat e-mailscanners en linkvoorbeelden uw link niet opgebruiken voordat u hem gebruikt.',
  'login.useDifferent': 'Ander adres gebruiken',
  'login.emailNoticeTitle': 'Uw e-mailadres is niet end-to-end versleuteld',
  'login.emailNoticeBody':
    'Het is een accountgegeven, gebruikt om u in te loggen en u te laten weten wanneer iemand aan een van uw links deelneemt. Gespreksinhoud staat daar los van en wordt in uw browser versleuteld.',
  'login.failed': 'De inloglink kon niet worden verstuurd. Probeer het zo meteen opnieuw.',
  'login.backToStart': 'Terug naar het begin',

  'confirm.checking': 'Inloglink controleren…',
  'confirm.title': 'Inloggen afronden',
  'confirm.subtitle': 'Nog één stap, met opzet.',
  'confirm.as': 'U staat op het punt in te loggen als {email}.',
  'confirm.explain':
    'Er is nog niets gebeurd. Deze link is nog ongebruikt en blijft dat tot u op „Doorgaan” drukt — daarom kan een scanner die hem opent u niet inloggen.',
  'confirm.continue': 'Doorgaan',
  'confirm.unavailable': 'Inloglink niet beschikbaar',
  'confirm.expired': 'Deze inloglink is verlopen. Links gelden {minutes} minuten.',
  'confirm.used': 'Deze inloglink is al gebruikt. Elke link werkt één keer.',
  'confirm.invalid': 'Deze inloglink is niet geldig.',
  'confirm.requestNew': 'Nieuwe link aanvragen',
  'confirm.failed': 'Inloggen is mislukt. Vraag een nieuwe link aan.',

  'messenger.newConversation': 'Nieuwe link',
  'messenger.newConversationHint':
    'Maakt een privélink. Stuur die naar één persoon; die voert een naam in en het gesprek begint.',
  'messenger.creatingLink': 'Bezig met aanmaken…',
  'messenger.someoneJoined': 'Iemand heeft een van uw links geopend.',
  'messenger.searchPlaceholder': 'Zoeken',
  'messenger.clearSearch': 'Zoekopdracht wissen',
  'messenger.filterAll': 'Alle',
  'messenger.filterUnread': 'Ongelezen',
  'messenger.filterActive': 'Actief',
  'messenger.filterEnded': 'Beëindigd',
  'messenger.emptyTitle': 'Nog geen gesprekken',
  'messenger.emptyBody': 'Maak een link en stuur die naar één persoon om te beginnen.',
  'messenger.noMatch': 'Niets komt overeen met deze zoekopdracht.',
  'messenger.loadingList': 'Gesprekken laden…',
  'messenger.welcomeTitle': 'Kairelo',
  'messenger.welcomeBody':
    'Stuur iemand een link en praat {hours} uur. Berichten worden in uw browser versleuteld en daarna blijft er niets bewaard.',
  'messenger.encrypted': 'End-to-end versleuteld',
  'messenger.opening': 'Gesprek openen…',
  'messenger.notOpenedYet':
    'Niemand heeft deze uitnodiging nog geopend. Het wordt een gesprek zodra iemand deelneemt.',
  'messenger.ended': 'Dit gesprek is beëindigd. Er is geen verslag.',
  'messenger.suspendedTitle': 'Account geschorst',
  'messenger.suspendedBody':
    'Bestaande links zijn ingetrokken en er kunnen geen nieuwe worden gemaakt.',

  'row.unusedInvitation': 'Ongebruikte uitnodiging',
  'row.invitationTitle': 'Uitnodiging',
  'row.invitationWaiting': 'Wacht om geopend te worden',
  'row.invitationExpiresToday': 'Verloopt vandaag',
  'row.invitationExpiresIn': 'Verloopt over {days} dagen',
  'row.visitor': 'Bezoeker',
  'row.conversation': 'Gesprek',
  'row.notOpened': 'Uitnodiging nog niet geopend',
  'row.ended': 'Dit gesprek is beëindigd',
  'row.deleted': 'Verwijderd',
  'row.noKey': 'Geen sleutel in deze browser',
  'row.joined': 'Deelgenomen',
  'row.joinedSayHello': 'Deelgenomen — zeg hallo',
  'row.messageCount': '{count} berichten',
  'row.messageCountOne': '1 bericht',
  'row.yesterday': 'Gisteren',

  'chat.online': 'online',
  'chat.offline': 'offline',
  'chat.typing': 'typt…',
  'chat.connecting': 'verbinden…',
  'chat.reconnecting': 'opnieuw verbinden…',
  'chat.conversationEnded': 'beëindigd',
  'chat.back': 'Terug naar gesprekken',
  'chat.about': 'Over dit gesprek',
  'chat.report': 'Melden',
  'chat.encryptionBanner':
    'Berichten worden in uw browser versleuteld. Dit gesprek eindigt vanzelf en laat geen verslag achter.',
  'chat.emptyWithKey': 'Nog geen berichten. Alles wat u stuurt wordt hier eerst versleuteld.',
  'chat.emptyNoKey':
    'Deze browser heeft de sleutel voor dit gesprek niet, dus de berichten kunnen hier niet worden gelezen.',
  'chat.endedComposer': 'Dit gesprek is beëindigd.',
  'chat.endNow': 'Gesprek nu beëindigen',
  'chat.endTitle': 'Dit gesprek nu beëindigen?',
  'chat.endBody':
    'De toegang eindigt voor u beiden onmiddellijk, en de versleutelde kopie van de dienst gaat volgens het gebruikelijke schema naar verwijdering.',
  'chat.endCaveat':
    'Het kan niets terughalen wat de ander al heeft gezien, bewaard of gescreenshot. Niets hier kan dat.',
  'chat.endConfirm': 'Nu beëindigen',
  'chat.ended': 'Gesprek beëindigd.',
  'chat.endFailed': 'Het gesprek kon niet worden beëindigd.',
  'chat.clearFromList': 'Uit lijst verwijderen',
  'chat.today': 'Vandaag',
  'chat.yesterday': 'Gisteren',

  'message.unreadable': 'Versleuteld bericht dat in deze browser niet kan worden gelezen',
  'message.tapToDecrypt': 'Tik om te ontsleutelen · {size}',
  'message.decrypting': 'Ontsleutelen…',
  'message.couldNotOpen': 'Kon niet worden geopend',
  'message.decryptAndDownload': 'Ontsleutelen en downloaden',
  'message.save': '{filename} opslaan',
  'message.testAdapter': 'testadapter',
  'message.sending': 'Versturen',
  'message.sent': 'Verstuurd',
  'message.failed': 'Niet verstuurd',
  'message.playVoice': 'Spraakbericht afspelen',
  'message.pauseVoice': 'Spraakbericht pauzeren',
  'message.playbackPosition': 'Afspeelpositie',

  'composer.placeholder': 'Typ een bericht',
  'composer.disabled': 'Geen sleutel in deze browser',
  'composer.emoji': 'Emoji',
  'composer.attach': 'Bijlage',
  'composer.photosVideos': "Foto's en video's",
  'composer.document': 'Document',
  'composer.record': 'Spraakbericht opnemen',
  'composer.stopAndSend': 'Opname stoppen en versturen',
  'composer.cancelRecording': 'Opname annuleren',
  'composer.recording': 'Opnemen',
  'composer.send': 'Versturen',
  'composer.notConnected': 'Niet verbonden. Het bericht is niet verstuurd.',
  'composer.fileFailed': 'Dat bestand kon niet worden verstuurd.',
  'composer.voiceFailed': 'Het spraakbericht is niet verstuurd.',

  'invite.title': 'Uitnodigingslink',
  'invite.subtitle': 'Eenmalig zichtbaar. De sleutel erin heeft de server nooit bereikt.',
  'invite.reveal': 'Klik om te tonen',
  'invite.revealLabel': 'Uitnodigingslink tonen',
  'invite.copied': 'Link gekopieerd. Stuur die naar slechts één persoon.',
  'invite.failed': 'De link kon niet worden gemaakt.',
  'invite.whatToKnow': 'Wat u over deze link moet weten',
  'invite.blockedTitle': 'Nieuwe links zijn geblokkeerd in deze browser',
  'invite.notCreated':
    '{detail} Er is geen link gemaakt, omdat de sleutel niet in deze browser bewaard kon worden en het gesprek onleesbaar zou zijn.',

  'join.opening': 'Uitnodiging openen…',
  'join.defaultBio':
    '{name} gebruikt Kairelo voor korte, privégesprekken. Berichten worden in uw browser versleuteld, en dit gesprek eindigt vanzelf zonder dat er een verslag bewaard blijft.',
  'join.invitedBy': 'U bent uitgenodigd voor een privégesprek',
  'join.title': 'Neem deel aan dit gesprek',
  'join.subtitle':
    'Kies een naam waaronder u bekend wilt zijn. Die wordt in uw browser versleuteld, dus de dienst ziet hem nooit.',
  'join.nameLabel': 'Uw weergavenaam',
  'join.namePlaceholder': 'Hoe moeten ze u noemen?',
  'join.nameHint':
    'Typen alleen doet niets. Het gesprek begint pas wanneer u op „Deelnemen” drukt.',
  'join.submit': 'Deelnemen aan gesprek',
  'join.failed': 'Deelnemen is mislukt. Probeer het zo meteen opnieuw.',
  'join.trustEncrypted': 'Versleuteld in uw browser',
  'join.trustEnds': 'Eindigt na {hours} uur',
  'join.trustNoAccount': 'Geen account nodig',
  'join.knowBefore': 'Wat u moet weten voordat u deelneemt',
  'join.unusableTitle': 'Deze link kan niet worden gebruikt',
  'join.claimed':
    'Iemand heeft al met deze link deelgenomen. Elke uitnodiging laat precies één bezoeker toe; latere pogingen worden geweigerd, ook met de juiste link.',
  'join.expired':
    'Deze uitnodiging is verlopen. Ongebruikte uitnodigingen gelden 30 dagen, en een gesprek duurt {hours} uur vanaf de start.',
  'join.invalid': 'Deze uitnodigingslink is niet geldig.',
  'join.askForNew': 'Vraag de persoon die hem stuurde om een nieuwe link.',
  'join.incompleteTitle': 'Deze link is onvolledig',
  'join.incompleteBody':
    'Het deel na de # bevat de sleutel die dit gesprek ontsleutelt. Die bereikt de server nooit en kan dus niet worden opgezocht of opnieuw verstuurd.',
  'join.incompleteHint':
    'De link is waarschijnlijk ingekort, afgekapt door een berichtenapp, of zonder het einde gekopieerd. Vraag opnieuw om de volledige link.',

  'visitor.languageNote':
    'Wordt alleen in deze browser bewaard. Het bepaalt de interface en de taal waarin ontvangen berichten worden vertaald.',
  'visitor.reconnecting': 'Opnieuw verbinden…',
  'visitor.noSessionTitle': 'Deze browser hoort niet bij dit gesprek',
  'visitor.noSessionBody':
    'Bij deelnemen ontstaat een sessiegegeven dat alleen in de deelnemende browser wordt bewaard. Deze browser heeft er geen.',
  'visitor.noSessionRecovery':
    'Als u hier hebt deelgenomen en uw browsergegevens hebt gewist, kan het gesprek niet worden hersteld — er is geen account als terugval.',
  'visitor.endedTitle': 'Dit gesprek is beëindigd',
  'visitor.endedBody':
    'De periode van {hours} uur is voorbij. Er is geen verslag, en de versleutelde kopie van de dienst staat in de wachtrij om verwijderd te worden.',
  'visitor.goToStart': 'Naar het begin',

  'report.title': 'Dit gesprek melden',
  'report.subtitle': 'Alles wat u hier schrijft wordt onversleuteld verstuurd en bewaard.',
  'report.warningTitle': 'De dienst kan uw gesprek niet lezen',
  'report.warningBody':
    'Het is versleuteld, dus een melding kan niet aan de inhoud worden getoetst. Wat u hieronder schrijft wordt leesbaar bewaard, samen met operationele gegevens zoals tijdstempels en uw IP-adres.',
  'report.reason': 'Reden',
  'report.reasonAbuse': 'Misbruik',
  'report.reasonHarassment': 'Intimidatie',
  'report.reasonIllegal': 'Illegale inhoud',
  'report.reasonSpam': 'Spam',
  'report.reasonOther': 'Anders',
  'report.details': 'Wat is er gebeurd',
  'report.detailsHint': 'Optioneel. Wordt onversleuteld bewaard.',
  'report.submit': 'Melding versturen',
  'report.sentTitle': 'Melding ontvangen',
  'report.sentBody': 'De melding is vastgelegd met de operationele gegevens van het gesprek.',
  'report.thanks': 'Dank u',
  'report.failed': 'De melding kon niet worden verstuurd. Probeer het zo meteen opnieuw.',

  'settings.title': 'Instellingen',
  'settings.languageTitle': 'Taal',
  'settings.languageSubtitle':
    'Gebruikt voor de interface en voor het vertalen van berichten die u ontvangt.',
  'settings.languageLabel': 'Uw taal',
  'settings.languageHint':
    'Binnenkomende berichten worden op uw eigen apparaat naar deze taal vertaald. Er wordt niets naar een vertaaldienst gestuurd.',
  'settings.languageSaved': 'Taal opgeslagen.',
  'settings.languageFailed': 'De taal kon niet worden opgeslagen.',
  'settings.interfaceUnavailableTitle':
    'Vertalen op het apparaat is niet beschikbaar in deze browser',
  'settings.interfaceUnavailableBody':
    'Uw taalkeuze geldt nog steeds voor de interface. Berichten komen binnen in de taal waarin ze zijn geschreven, want ze vertalen zou betekenen dat ze naar een dienst worden gestuurd — wat dit product niet doet.',
  'settings.translationAvailableTitle': 'Vertalen op het apparaat is beschikbaar',
  'settings.translationAvailableBody':
    'Berichten die u ontvangt worden in deze browser automatisch naar uw taal vertaald. Er wordt niets naar een vertaaldienst gestuurd.',
  'settings.interfaceTitle': 'Interface',
  'settings.interfaceSubtitle':
    'Hoe de chat eruitziet. Er zijn meer stijlen gepland; vandaag is er één beschikbaar.',
  'settings.interfaceLabel': 'Interfacestijl',
  'settings.accountTitle': 'Uw account',
  'settings.backToConversations': 'Terug naar gesprekken',
  'settings.uiTranslated': 'Interface vertaald',
  'settings.uiEnglish': 'Interface in het Engels',
  'settings.uiEnglishNote':
    'Berichten worden nog steeds naar deze taal vertaald; de interface zelf is nog niet vertaald.',

  /* ------------------------------------------------------------ landing */
  'landing.heroLine1': 'Eén ruimte.',
  'landing.heroLine2': 'Eén gesprek.',
  'landing.heroLine3': 'Na 24 uur weg.',
  'landing.heroBody':
    'Deel een link. De ander vult een naam in en komt erbij. Je praat een dag, en dan is het voorbij — geen transcript, geen archief, niets om te verwijderen.',
  'landing.signIn': 'Inloggen met e-mail',
  'landing.noAccount': 'Geen account. Geen download.',
  'landing.ringLabel': 'en het is voorbij',

  'landing.howTitle': 'Hoe het werkt',
  'landing.step1Title': 'Deel een link',
  'landing.step1Body': 'Je maakt een link en deelt die met één persoon.',
  'landing.step2Title': 'Die vult een naam in',
  'landing.step2Body': 'Geen account, geen download. Een weergavenaam is genoeg.',
  'landing.step3Title': 'Chat 24 uur',
  'landing.step3Body': 'Daarna is alles weg.',

  'landing.getTitle': 'Wat je krijgt',
  'landing.feature1Title': 'Deel een privélink',
  'landing.feature1Body':
    'Je browser maakt de sleutel en zet die in het fragment van de link — het deel dat browsers nooit naar een server sturen.',
  'landing.feature2Title': 'Naam invullen en meedoen',
  'landing.feature2Body':
    'Geen registratie, geen account, geen app. De ander typt een weergavenaam en begint te praten.',
  'landing.feature3Title': 'Na 24 uur is het voorbij',
  'landing.feature3Body':
    'De toegang stopt, er is geen transcript en geen archief, en de versleutelde kopie wordt verwijderd.',
  'landing.feature4Title': 'Eind-tot-eind versleuteld',
  'landing.feature4Body':
    'Berichten, foto’s, video’s, bestanden en spraakberichten worden in je browser versleuteld voordat ze worden verstuurd.',
  'landing.feature5Title': 'Wij kunnen het niet lezen',
  'landing.feature5Body':
    'In normale werking geeft de dienst versleutelde tekst door en slaat die op, en krijgt de sleutel nooit.',

  'landing.carriesTitle': 'Wat een gesprek kan bevatten',
  'landing.carriesMessages': 'Berichten',
  'landing.carriesPhotos': 'Foto’s',
  'landing.carriesVideos': 'Video’s',
  'landing.carriesFiles': 'Bestanden',
  'landing.carriesVoice': 'Spraakberichten',

  'landing.notTitle': 'Wat dit niet is',
  'landing.notBody1':
    'Het is niet anoniem: de dienst ziet nog steeds IP-adressen, tijdstippen en browserinformatie. Het is niet onafhankelijk gecontroleerd. Er wordt geen geschiktheid geclaimd voor gereguleerd professioneel gebruik.',
  'landing.notBody2':
    'Een gesprek is alleen te lezen in het browserprofiel waarin het is gemaakt of waarmee is deelgenomen. Raak je dat profiel kwijt, dan is het gesprek onleesbaar — voor iedereen, ook voor ons.',
  'landing.languageLabel': 'Taal',

  /* -------------------------------------------------------- disclosures */
  'disclosure.copyingTitle': 'Alles op het scherm kan worden gekopieerd',
  'disclosure.copyingBody':
    'Beide personen kunnen dit gesprek screenshotten, opnemen of fotograferen. Versleuteling voorkomt dat de dienst meeleest; het voorkomt niet dat de ander een kopie bewaart.',
  'disclosure.bearerTitle': 'Behandel de link als een geheim',
  'disclosure.bearerBody':
    'Zolang niemand is toegetreden, kan wie de link heeft als eerste meedoen. Versturen via e-mail of chat, of achterlaten in klembordgeschiedenis, browsergeschiedenis of een screenshot, kan de link buiten de dienst blootstellen. Stuur hem naar één persoon en alleen naar die persoon.',
  'disclosure.deviceKeyTitle': 'Alleen deze browser kan dit gesprek lezen',
  'disclosure.deviceKeyBody':
    'De sleutel wordt hier gemaakt en hier bewaard. Inloggen op een ander apparaat geeft je geen toegang, en de e-mailmelding elders volgen ook niet. De opslag van deze browser wissen, privé browsen, of dit apparaat verliezen maakt het gesprek permanent onleesbaar. Er is geen herstel.',
  'disclosure.scopeTitle': 'Wat wel en niet versleuteld is',
  'disclosure.scopeBody1':
    'Berichten, foto’s, video’s, bestanden, spraakberichten en de weergavenaam van de bezoeker worden in de browser versleuteld. Het profiel van de eigenaar, het account-e-mailadres en operationele gegevens zoals tijdstippen en IP-adressen zijn dat niet, en worden ook niet als eind-tot-eind versleuteld omschreven.',
  'disclosure.scopeBody2':
    'Omdat de versleutelingscode als webpagina wordt geleverd, zou een gecompromitteerde installatie van deze dienst aangepaste code kunnen serveren. Dat is een beperking van versleuteling via de browser en is niet met ontwerp alleen weg te nemen. De cryptografie hier is niet onafhankelijk gecontroleerd.',
  'disclosure.notAnonymousTitle': 'Zonder registratie is niet anoniem',
  'disclosure.notAnonymousBody':
    'Je hebt geen account nodig en je weergavenaam is versleuteld. De dienst ziet nog steeds operationele gegevens zoals je IP-adres, tijdstippen en browserinformatie, die worden gebruikt voor snelheidslimieten en misbruikbestrijding.',
  'disclosure.temporaryTitle': 'Dit gesprek eindigt vanzelf',
  'disclosure.temporaryBody':
    'Het blijft {hours} uur open nadat het begint. Daarna kan geen van beiden opnieuw verbinden, is er geen transcript, en verwijdert de dienst de versleutelde kopie die zij bewaart. Back-ups verlopen apart op hun eigen schema.',
};
